import axios from 'axios';
import {
  LIST_DAILY_PERFORMANCE_ENDPOINT,
  LIST_MONTHLY_PERFORMANCE_ENDPOINT,
  LIST_FIFTEEN_MINUTE_PRODUCTION_ENDPOINT,
  LIST_HOURLY_BATTERY_ENDPOINT,
  LIST_DAILY_BATTERY_ENDPOINT,
  LIST_YEARLY_PERFORMANCE_ENDPOINT,
  LIST_CONTRACT_GENERATIONS_MONTHLY_ENDPOINT,
} from '../constants/endpoint';

const ListFifteenMinuteProduction = async (prospectId, startDate, endDate) => {
  const body = {
    startDate: new Date(startDate).toISOString(),
    endDate: new Date(endDate).toISOString(),
  };
  const response = await axios.post(`${LIST_FIFTEEN_MINUTE_PRODUCTION_ENDPOINT}/${prospectId}`, body);
  return response;
};

const ListHourlyBattery = async (prospectId, startDate, endDate) => {
  const body = {
    startDate: new Date(startDate).toISOString(),
    endDate: new Date(endDate).toISOString(),
  };
  const response = await axios.post(`${LIST_HOURLY_BATTERY_ENDPOINT}/${prospectId}`, body);
  return response;
};

const ListDailyBattery = async (prospectId, startDate, endDate) => {
  const body = {
    startDate: new Date(startDate).toISOString(),
    endDate: new Date(endDate).toISOString(),
  };

  const response = await axios.post(`${LIST_DAILY_BATTERY_ENDPOINT}/${prospectId}`, body);
  return response;
};

const ListDailyPerformance = async (prospectId, startDate, endDate) => {
  const body = {
    startDate: new Date(startDate).toISOString(),
    endDate: new Date(endDate).toISOString(),
  };

  const response = await axios.post(`${LIST_DAILY_PERFORMANCE_ENDPOINT}/${prospectId}`, body);
  return response;
};

const ListMonthlyPerformance = async (prospectId, startDate, endDate) => {
  const body = {
    startDate: new Date(startDate).toISOString(),
    endDate: new Date(endDate).toISOString(),
  };
  const response = await axios.post(`${LIST_MONTHLY_PERFORMANCE_ENDPOINT}/${prospectId}`, body);
  return response;
};

const ListYearlyPerformance = async (prospectId, startDate, endDate) => {
  const body = {
    startDate: new Date(startDate).toISOString(),
    endDate: new Date(endDate).toISOString(),
  };
  const response = await axios.post(`${LIST_YEARLY_PERFORMANCE_ENDPOINT}/${prospectId}`, body);
  return response;
};

const ListContractGenerationsMonthly = async (prospectId, startDate, endDate) => {
  const body = {
    startDate: new Date(startDate).toISOString(),
    endDate: new Date(endDate).toISOString(),
  };
  const response = await axios.post(`${LIST_CONTRACT_GENERATIONS_MONTHLY_ENDPOINT}/${prospectId}`, body);
  return response;
};

export {
  ListFifteenMinuteProduction,
  ListDailyPerformance,
  ListMonthlyPerformance,
  ListHourlyBattery,
  ListDailyBattery,
  ListYearlyPerformance,
  ListContractGenerationsMonthly,
};
